import Routers from './routers';
import { OverviewContextProvider } from 'store/overview-context';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useEffect } from 'react';

const queryClient = new QueryClient();

function App() {
	useEffect(() => {
		document.addEventListener(
			'touchmove',
			function (event) {
				event = event.originalEvent || event;
				if (event.scale > 1) {
					event.preventDefault();
				}
			},
			false
		);
	}, []);
	return (
		<div className='App'>
			<QueryClientProvider client={queryClient}>
				<OverviewContextProvider>
					<Routers />
				</OverviewContextProvider>
			</QueryClientProvider>
		</div>
	);
}

export default App;
